<template>
  <div class="upper-wrp" v-show="isShow">
    <div class="upper-inner" @click="noScroll2Top"></div>
  </div>
</template>

<script>
  import {scroll2Top} from '../../utils';

  export default {
    name: 'scroll-to-top',
    data(){
      return {
        isShow: false,
      };
    },
    mounted(){
      this.bindScroll();
    },
    destroyed(){
      this.removeScroll();
    },
    methods: {
      bindScroll(){
        window.addEventListener('scroll', this._eventCallback, false);
      },

      removeScroll(){
        window.removeEventListener('scroll', this._eventCallback);
      },

      _eventCallback(ev){
        let scrollT = document.documentElement.scrollTop || document.body.scrollTop;  // 滚动条高度
        let footerOffsetTop = document.querySelector('.footer_x').offsetTop;  // 页脚的top值
        let clientHeight = document.documentElement.clientHeight;   // 屏幕高度

        if(scrollT >= 700 && scrollT <= footerOffsetTop -  clientHeight){
          this.isShow = true;
        }else{
          this.isShow = false;
        }
      },

      /** 滚动到顶部 */
      noScroll2Top(){
        scroll2Top();
      },
    },
  }
</script>

<style lang="scss" scoped>
  .upper-wrp{
    position: fixed;
    width: 1100px;
    left: 50%;
    bottom: 15px;
    /*margin: 0 auto;*/
    transform: translateX(-50%);
  }
  .upper-inner{
    position: absolute;
    right: -70px;
    bottom: 0;
    width: 50px;
    height: 50px;
    border: 1px solid #E1E1E1;
    border-radius: 4px;
    background: url("/static/images/btn_up_list.png") no-repeat center center;
    cursor: pointer;

    &:hover{
      border-color: #4BC5F4;
      background: url("/static/images/btn_up_list_blue.png") no-repeat center center;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/ScrollToTop/ScrollToTop.vue